import { Button } from '../../../atoms'
import React from 'react'

interface TravelOtherProps {
  text: string
  buttonText: string
  href: string
}

const TravelOther: React.FC<TravelOtherProps> = ({ text, buttonText, href }) => {
  return (
    <div className='TravelOther'>
      <div className='TravelOther__text'>{text}</div>
      <div className='TravelOther__cta'>
        <Button href={href} withIcon={false}>
          {buttonText}
        </Button>
      </div>
    </div>
  )
}

export default TravelOther
